import { useState, useEffect } from 'react';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Modal from 'react-bootstrap/Modal';
import "./productVariantModal.css"
import { useTranslation } from 'react-i18next';
import { FaMinus, FaPlus, FaShoppingCart } from 'react-icons/fa';
import { useSelector, useDispatch } from 'react-redux';
import * as newApi from "../../api/apiCollection"
import { addGuestCartTotal, addtoGuestCart, setCart, setCartProducts, setCartSubTotal, subGuestCartTotal } from '../../model/reducer/cartReducer';
import { toast } from 'react-toastify';

function ProductVariantModal({ product, showVariantModal, setShowVariantModal }) {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const setting = useSelector(state => (state.setting));
    const cart = useSelector(state => (state.cart));
    const user = useSelector(state => (state.user));

    const [selectedVariant, setSelectedVariant] = useState(null);
    const [selectedColor, setSelectedColor] = useState(null);
    const [selectedSize, setSelectedSize] = useState(null);

    // Helper functions for parsing variant data
    const getVariantColors = (variant) => {
        try {
            if (!variant?.colors) return [];
            const colors = JSON.parse(variant.colors);
            return Array.isArray(colors) ? colors : [];
        } catch (error) {
            console.error('Error parsing colors:', error);
            return [];
        }
    };

    const getVariantSizes = (variant) => {
        try {
            if (!variant?.size) return [];
            const sizes = JSON.parse(variant.size);
            return Array.isArray(sizes) ? sizes : [];
        } catch (error) {
            console.error('Error parsing sizes:', error);
            return [];
        }
    };

    const isClothingProduct = (variant) => {
        return variant?.variant_type === 'clothes';
    };

    useEffect(() => {
        if (product?.variants?.length > 0) {
            const defaultVariant = product.variants[0];
            setSelectedVariant(defaultVariant);
            
            // Set default color and size if available
            const colors = getVariantColors(defaultVariant);
            const sizes = getVariantSizes(defaultVariant);
            
            if (colors.length > 0) {
                setSelectedColor(colors[0]);
            }
            
            if (sizes.length > 0) {
                setSelectedSize(sizes[0]);
            }
        }
    }, [product]);

    const handleClose = () => {
        setShowVariantModal(false);
    };

    // تعديل البحث عن المنتج في السلة ليشمل اللون والمقاس
    const isProductAlreadyAdded = (
        (cart?.isGuest === false && 
            cart?.cartProducts?.find((prdct) => 
                prdct?.product_variant_id === selectedVariant?.id &&
                prdct?.selected_color === selectedColor &&
                prdct?.selected_size === selectedSize
            )?.qty > 0) ||
        (cart?.isGuest === true && 
            cart?.guestCart?.find((prdct) => 
                prdct?.product_variant_id === selectedVariant?.id &&
                prdct?.selected_color === selectedColor &&
                prdct?.selected_size === selectedSize
            )?.qty > 0)
    );

    const addedQuantity = cart?.isGuest === false
        ? cart?.cartProducts?.find(prdct => 
            prdct?.product_variant_id === selectedVariant?.id &&
            prdct?.selected_color === selectedColor &&
            prdct?.selected_size === selectedSize
          )?.qty || 0
        : cart?.guestCart?.find(prdct => 
            prdct?.product_variant_id === selectedVariant?.id &&
            prdct?.selected_color === selectedColor &&
            prdct?.selected_size === selectedSize
          )?.qty || 0;

    // تعديل منطق الإضافة للسلة ليضيف منتج جديد إذا لم يوجد مطابق بنفس اللون والمقاس
    const addToCart = async (productId, productVId, qty) => {
        try {
            const response = await newApi.addToCart({ 
                product_id: productId, 
                product_variant_id: productVId, 
                qty: qty,
                selected_color: selectedColor,
                selected_size: selectedSize
            });
            
            if (response.status === 1) {
                const existingProduct = cart?.cartProducts?.find((product) => 
                    product?.product_id == productId && 
                    product?.product_variant_id == productVId &&
                    product?.selected_color === selectedColor &&
                    product?.selected_size === selectedSize
                );
                
                if (!existingProduct?.qty) {
                    // Add new product to cart
                    dispatch(setCart({ data: response }));
                    const updatedCartCount = [...cart?.cartProducts, { 
                        product_id: productId, 
                        product_variant_id: productVId, 
                        qty: qty,
                        selected_color: selectedColor,
                        selected_size: selectedSize 
                    }];
                    dispatch(setCartProducts({ data: updatedCartCount }));
                    dispatch(setCartSubTotal({ data: response?.sub_total }));
                } else {
                    // Update existing product quantity
                    const updatedProducts = cart?.cartProducts?.map(product => {
                        if (product.product_id == productId && product?.product_variant_id == productVId && product?.selected_color === selectedColor && product?.selected_size === selectedSize) {
                            return { 
                                ...product, 
                                qty: qty,
                                selected_color: selectedColor,
                                selected_size: selectedSize 
                            };
                        }
                        return product;
                    });
                    dispatch(setCart({ data: response }));
                    dispatch(setCartProducts({ data: updatedProducts }));
                    dispatch(setCartSubTotal({ data: response?.sub_total }));
                }
            }
        } catch (error) {
            console.log("error", error)
        }
    }
    const removeFromCart = async (productId, variantId) => {
        try {
            const response = await newApi.removeFromCart({ 
                product_id: productId, 
                product_variant_id: variantId,
                selected_color: selectedColor,
                selected_size: selectedSize
            })
            if (response?.status === 1) {
                const updatedProducts = cart?.cartProducts?.filter(product => {
                    // حذف المنتج المحدد فقط (نفس product_id, product_variant_id, selected_color, selected_size)
                    return !(product?.product_id === productId && 
                            product?.product_variant_id === variantId &&
                            product?.selected_color === selectedColor &&
                            product?.selected_size === selectedSize);
                });
                dispatch(setCartSubTotal({ data: response?.sub_total }));
                dispatch(setCartProducts({ data: updatedProducts }));
            } else {
                toast.error(response.message)
            }
        } catch (error) {
            console.log("error", error)
        }
    }
    const getProductQuantities = (products) => {
        if (!products || !Array.isArray(products) || products.length === 0) {
            return [];
        }
        return Object.entries(products.reduce((quantities, product) => {
            if (!product || !product.product_id) {
                return quantities;
            }
            const existingQty = quantities[product.product_id] || 0;
            return { ...quantities, [product.product_id]: existingQty + (product.qty || 0) };
        }, {})).map(([productId, qty]) => ({
            product_id: parseInt(productId),
            qty
        }));
    }
    const handleValidateAddNewProduct = (productQuantity, product, variant) => {
        const productQty = productQuantity?.find(prdct => prdct?.product_id == product?.id)?.qty
        if ((productQty) >= Number(product?.total_allowed_quantity)) {
            toast.error('Oops, Limited Stock Available');
        }
        else if (Number(product.is_unlimited_stock)) {
            addToCart(product.id, variant?.id, 1);
        } else {
            if (variant?.status) {
                addToCart(product.id, variant?.id, 1);
            } else {
                toast.error('Oops, Limited Stock Available');
            }
        }

    };
    const handleValidateAddExistingProduct = (productQuantity, product, variant) => {
        const productQty = productQuantity?.find(prdct => prdct?.product_id == product?.id)?.qty
        if (Number(product.is_unlimited_stock)) {
            if (productQty < Number(product?.total_allowed_quantity)) {
                addToCart(product.id, variant?.id, cart?.cartProducts?.find(prdct => prdct?.product_variant_id == variant?.id)?.qty + 1);
            } else {
                toast.error('Apologies, maximum product quantity limit reached!');
            }
        } else {
            if (productQty >= Number(variant?.stock)) {
                toast.error(t("out_of_stock_message"));
            }
            else if (Number(productQty) >= Number(product.total_allowed_quantity)) {
                toast.error('Apologies, maximum product quantity limit reached');
            } else {
                addToCart(product.id, variant?.id, cart?.cartProducts?.find(prdct => prdct?.product_variant_id == variant?.id)?.qty + 1);
            }
        }
    };
    const handleAddNewProductGuest = (productQuantity, product, variant) => {
        const productQty = productQuantity?.find(prdct => prdct?.product_id == product?.id)?.qty
        if (Number(productQty || 0) < Number(product.total_allowed_quantity)) {
            AddToGuestCart(product, product.id, variant?.id, 1, 0, variant, "add");
        } else {
            toast.error(t("out_of_stock_message"));
        }
    };
    const AddToGuestCart = (product, productId, productVariantId, Qty, isExisting, variant, flag) => {
        const now = new Date();
        const startDate = variant?.discount_start_date ? new Date(variant.discount_start_date) : null;
        const endDate = variant?.discount_end_date ? new Date(variant.discount_end_date) : null;
        const isDiscountActive = variant?.discounted_price && 
                               variant?.discounted_price !== 0 && 
                               variant?.discounted_price < variant?.price &&
                               startDate && endDate &&
                               now >= startDate && now <= endDate;
        const finalPrice = isDiscountActive ? variant?.discounted_price : variant?.price
        if (isExisting) {
            let updatedProducts;
            if (Qty !== 0) {
                if (flag == "add") {
                    dispatch(addGuestCartTotal({ data: finalPrice }));
                } else if (flag == "remove") {
                    dispatch(subGuestCartTotal({ data: finalPrice }));
                }
                updatedProducts = cart?.guestCart?.map((product) => {

                    if (product?.product_id == productId && product?.product_variant_id == productVariantId) {
                        return { ...product, qty: Qty };
                    } else {
                        return product;
                    }

                });

            } else {
                if (flag == "add") {
                    dispatch(addGuestCartTotal({ data: finalPrice }));
                } else if (flag == "remove") {
                    dispatch(subGuestCartTotal({ data: finalPrice }));
                }
                updatedProducts = cart?.guestCart?.filter(product => {
                    return (
                        product?.product_id != productId || product?.product_variant_id != productVariantId
                    )
                }
                );

                // dispatch(subGuestCartTotal({ data: finalPrice }));
            }

            dispatch(addtoGuestCart({ data: updatedProducts }));

        } else {
            if (flag == "add") {
                dispatch(addGuestCartTotal({ data: finalPrice }));
            } else if (flag == "remove") {
                dispatch(subGuestCartTotal({ data: finalPrice }));
            }
            // dispatch(addGuestCartTotal({ data: finalPrice }))
            const productData = { product_id: productId, product_variant_id: productVariantId, qty: Qty };
            dispatch(addtoGuestCart({ data: [...cart?.guestCart, productData] }));
        }
    };
    const handleValidateAddExistingGuestProduct = (productQuantity, product, quantity, variant) => {
        const productQty = productQuantity?.find(prdct => prdct?.product_id == product?.id)?.qty;
        console.log("product qty", quantity)
        if (Number(product.is_unlimited_stock)) {
            if (productQty >= Number(product?.total_allowed_quantity)) {
                toast.error('Apologies, maximum product quantity limit reached');
            }
            else {
                AddToGuestCart(product, product?.id, variant?.id, quantity, 1, variant, "add");
            }
        }
        else {
            if (productQty >= Number(variant?.stock)) {
                toast.error('Oops, Limited Stock Available');
            }
            else if (productQty >= Number(product?.total_allowed_quantity)) {
                toast.error('Apologies, maximum cart quantity limit reached');
            }
            else {

                AddToGuestCart(product, product?.id, variant?.id, quantity, 1, variant, "add");
            }
        }
    };

    const handleVariantSelect = (variant) => {
        setSelectedVariant(variant);
        
        // Reset and set new default color and size
        const colors = getVariantColors(variant);
        const sizes = getVariantSizes(variant);
        
        if (colors.length > 0) {
            setSelectedColor(colors[0]);
        }
        
        if (sizes.length > 0) {
            setSelectedSize(sizes[0]);
        }
    };

    const handleColorSelect = (color) => {
        setSelectedColor(color);
    };

    const handleSizeSelect = (size) => {
        setSelectedSize(size);
    };

    const handleAddToCart = (variant) => {
        // Add the product with selected variant, color, and size
        const cartItem = {
            ...variant,
            selected_color: selectedColor,
            selected_size: selectedSize
        };
        
        if (cart?.isGuest) {
            const quantity = getProductQuantities(cart?.cartProducts);
            handleAddNewProductGuest(quantity, product, cartItem);
        } else {
            const quantity = getProductQuantities(cart?.cartProducts);
            handleValidateAddNewProduct(quantity, product, cartItem);
        }
    };

    return (
        <>
            <Modal show={showVariantModal} onHide={handleClose} size='md' centered>
                <Modal.Header closeButton>
                    <Modal.Title>{t("productVariants")}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className='product-info'>
                        <img src={product?.image_url} alt={product?.name} />
                        <p>{product?.name}</p>
                    </div>
                    <div className='product-variants'>
                        {product?.variants?.map((variant) => {
                            const isSelected = selectedVariant?.id === variant.id;
                            return (
                                <div key={variant.id} className='variant-container'>
                                    <div className={`variant-row row d-flex align-items-center ${isSelected ? 'selected' : ''}`}>
                                        <div className='col-4 col-lg-7' onClick={() => handleVariantSelect(variant)}>
                                            {`${variant?.measurement} ${variant?.stock_unit_name}`}
                                        </div>
                                        {variant?.is_unlimited_stock === 0 && variant?.stock <= 0 ? (
                                            <span className='col-5 mr-4 variant-out-of-stock'>{t("OutOfStock")}</span>
                                        ) : (
                                            <>
                                                <div className='col-4 col-lg-2 mr-4 variant-price price-saudi'>
                                                    {(() => {
                                                        const now = new Date();
                                                        const startDate = variant?.discount_start_date ? new Date(variant.discount_start_date) : null;
                                                        const endDate = variant?.discount_end_date ? new Date(variant.discount_end_date) : null;
                                                        const isDiscountActive = variant?.discounted_price && 
                                                                               variant?.discounted_price !== 0 && 
                                                                               variant?.discounted_price < variant?.price &&
                                                                               startDate && endDate &&
                                                                               now >= startDate && now <= endDate;

                                                        return isDiscountActive ? variant?.discounted_price : variant?.price;
                                                    })()}
                                                </div>
                                                <div className='col-4 col-lg-3'>
                                                    {isSelected && isClothingProduct(variant) && (
                                                        <div className="variant-options">
                                                            {/* Colors */}
                                                            {getVariantColors(variant).length > 0 && (
                                                                <div className="color-options">
                                                                    <label>{t("colors")}</label>
                                                                    <div className="colors-container">
                                                                        {getVariantColors(variant).map((color, index) => (
                                                                            <div
                                                                                key={index}
                                                                                className={`color-item ${selectedColor === color ? 'selected' : ''}`}
                                                                                style={{ backgroundColor: color }}
                                                                                onClick={() => handleColorSelect(color)}
                                                                                title={color}
                                                                            />
                                                                        ))}
                                                                    </div>
                                                                </div>
                                                            )}
                                                            
                                                            {/* Sizes */}
                                                            {getVariantSizes(variant).length > 0 && (
                                                                <div className="size-options">
                                                                    <label>{t("sizes")}</label>
                                                                    <div className="sizes-container">
                                                                        {getVariantSizes(variant).map((size, index) => (
                                                                            <div
                                                                                key={index}
                                                                                className={`size-item ${selectedSize === size ? 'selected' : ''}`}
                                                                                onClick={() => handleSizeSelect(size)}
                                                                            >
                                                                                {size}
                                                                            </div>
                                                                        ))}
                                                                    </div>
                                                                </div>
                                                            )}
                                                        </div>
                                                    )}
                                                    {isProductAlreadyAdded ? (
    <div className="quantity-controls">
        <button onClick={() => {
            // نقص الكمية
            const existing = cart?.cartProducts?.find(prdct => prdct?.product_variant_id === selectedVariant?.id && prdct?.selected_color === selectedColor && prdct?.selected_size === selectedSize);
            if (existing && existing.qty > 1) {
                addToCart(product.id, selectedVariant.id, existing.qty - 1);
            } else if (existing && existing.qty === 1) {
                removeFromCart(product.id, selectedVariant.id);
            }
        }}><FaMinus /></button>
        <span>{addedQuantity}</span>
        <button onClick={() => {
            addToCart(product.id, selectedVariant.id, addedQuantity + 1);
        }}><FaPlus /></button>
    </div>
) : (
    <button 
        className='product-cart-btn' 
        onClick={() => handleAddToCart(selectedVariant)}
        disabled={selectedVariant?.is_unlimited_stock === 0 && selectedVariant?.stock <= 0}
    >
        <FaShoppingCart className='mx-2' size={20} />
        {t("add_cart")}
    </button>
)}
                                                </div>
                                            </>
                                        )}
                                        </div>
                                </div>
                            );
                        })}
                    </div>
                </Modal.Body>
            </Modal>
        </>
    );
}

export default ProductVariantModal;
